import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import StudioForm from "./StudioForm";
import AvailableCalendar from "../utils/Calendar/Main";
import {
  getStudiosOption,
  getBookingData,
  getStudioData,
} from "../../services/api/api";
import { ToastContainer } from "react-toastify";
import { showToast } from "../utils/Function/Helper";
import "./ViewAvailability.css";

export default function ViewAvailability() {
  const user = useSelector((state) => state.user);
  const [bookingData, setBookingData] = useState([]);
  const [studioData, setStudioData] = useState({});  
  const teamData = [{
    id: "1",
    name: "Team_1",
  }];
  const [studiosOption, setStudiosOption] = useState([]);
  const [page, setPage] = useState(0);
  const FormTitles = ["Studio Details", "Slot Details"];
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  
  useEffect(() => {    
    const fetchStudiosName = async () => {
      try {
        const data = await getStudiosOption({superadmin_id: user?.userDetails?.ID || null,  teamlead_id: user?.userDetails?.TeamLeadID || null});
        if (data.status) {
          setStudiosOption(data.data);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };

    const fetchStudioData = async (studio_id) => {
      try {
        const data = await getStudioData({superadmin_id: user?.userDetails?.ID || null, id: studio_id});
        if (data.status) {
          setStudioData(data.data);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };

    if (formData.studio_id) {
      fetchStudioData(formData.studio_id);
    }

    fetchStudiosName();
  }, [user, formData.studio_id]); // Only runs on initial render

  useEffect (()=>{
    const fetchBookingData = async (studio_id) => {
      try {       
        const data = await getBookingData({superadmin_id: user?.userDetails?.ID || null, teamlead_id: studioData?.teamlead_id || null, studio_id: studio_id});
        if (data.status) {
          setBookingData(data.data);
        } else {
          setBookingData([]);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };

    if (studioData) {
      fetchBookingData(formData.studio_id);
    }
  },[user, studioData]);

  const validateStep = () => {
    const newErrors = {};
    if (page === 0) {
      if (!formData.studio_id) newErrors.studio_id = "Studio is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const PageDisplay = () => {
    if (page === 0) {
      return (
        <StudioForm
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          studiosOption={studiosOption}
        />
      );
    } else if (page === 1) {
      return (
        <AvailableCalendar
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          setBookingData={setBookingData}
          bookingData={bookingData}
          studioData={studioData}
          teamData={teamData}
        />
      );
    }
  };

  const handleBack = () => {
    setPage((currPage) => currPage - 1); // Go to the previous page
  };

  const handleSubmit = async () => {
    if (page !== FormTitles.length - 1) {
      if (validateStep()) {
        setPage((currPage) => currPage + 1); // Go to the next page
      }
    }
  };

  return (
    <div className="availability-container">
      <ToastContainer />

      <div className="form">
        <div className="form-container">
          {/* Progress Step */}
          <div className="progressbar">
            {FormTitles.map((title, index) => {
              // Log the current title and index

              return (
                <div key={index} className="step-container">
                  <div
                    className={`step ${page > index ? "completed" : ""} ${
                      page === index ? "activeprogress" : ""
                    }`}
                  >
                    <span>{page > index ? "✔" : index + 1}</span>{" "}
                    {/* Show checkmark for completed steps */}
                    <p>{title}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Form Title */}
          <div className="slot-header">
            <h1>{FormTitles[page]}</h1>
          </div>

          {/* Form Body */}
          <div className="slot-body">{PageDisplay()}</div>

          {/* Navigation Buttons */}
          <div className="slot-footer">
            <button disabled={page === 0} onClick={handleBack}>
              Back
            </button>
            <button disabled={page === 1} onClick={handleSubmit}>
              {page === FormTitles.length - 1 ? "Book a Slot" : "Next"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
